// Translations for Ikons Agency

export const translations = {
  es: {
    nav: {
      services: "Servicios",
      specialization: "Especialización",
      founder: "Founder",
      faq: "FAQ",
      contact: "Contacto"
    },
    hero: {
      title: "IKONS AGENCY",
      subtitle: "Representación Estratégica de Fútbol",
      tagline: ["Gestión de élite.", "Visión internacional.", "Estructura a largo plazo."],
      cta: {
        primary: "SOLICITAR CONSULTA PRIVADA",
        secondary: "CONTACTAR POR WHATSAPP"
      }
    },
    vision: {
      headline: "La diferencia está en la estructura.",
      subheadline: "El talento abre puertas. La estrategia construye carreras.",
      description: [
        "En Ikons Agency trabajamos con planificación, criterio y visión internacional.",
        "Cada decisión responde a una estrategia.",
        "Cada movimiento tiene propósito.",
        "",
        "No improvisamos operaciones.",
        "Diseñamos trayectorias sostenibles."
      ]
    },
    about: {
      title: "QUIÉNES SOMOS",
      description: "Ikons Agency es una firma de representación y asesoría estratégica en la industria del fútbol.",
      features: [
        "Experiencia deportiva real",
        "Conocimiento profundo del mercado",
        "Red internacional consolidada",
        "Negociación profesional",
        "Gestión integral de carrera"
      ],
      tagline: "Operamos con discreción, precisión y enfoque a largo plazo."
    },
    services: {
      title: "SERVICIOS",
      list: [
        {
          id: 1,
          title: "Representación Deportiva",
          description: "Gestión integral de la carrera profesional de jugadores, jugadoras y entrenadores.",
          features: [
            "Negociación contractual",
            "Estrategia de traspasos",
            "Planificación deportiva",
            "Protección y valorización del activo",
            "Acompañamiento estratégico continuo"
          ],
          tagline: "Construimos carreras, no temporadas.",
          special: true
        },
        {
          id: 2,
          title: "Representación de Imagen",
          description: "Desarrollo y posicionamiento estratégico de marca personal.",
          features: [
            "Gestión de patrocinios",
            "Acuerdos comerciales",
            "Construcción de identidad pública",
            "Proyección mediática",
            "Activación de sponsorship"
          ],
          tagline: "La marca también compite."
        },
        {
          id: 3,
          title: "Intermediación Deportiva",
          description: "Ejecución profesional de operaciones entre clubes y profesionales.",
          features: [
            "Negociaciones estratégicas",
            "Gestión de transferencias",
            "Operaciones confidenciales",
            "Estructuración de acuerdos complejos"
          ],
          tagline: "Precisión, criterio y confidencialidad."
        },
        {
          id: 4,
          title: "Representación de Clubes",
          description: "Asesoramiento estratégico en procesos de compraventa de jugadores.",
          features: [
            "Identificación de talento",
            "Análisis de mercado",
            "Estructuración de operaciones",
            "Apoyo en negociaciones"
          ],
          tagline: "Socios estratégicos del club."
        },
        {
          id: 5,
          title: "Asesoría en Gestión Deportiva",
          description: "Consultoría estratégica para clubes, federaciones y estructuras deportivas.",
          features: [
            "Planificación deportiva",
            "Optimización de recursos",
            "Desarrollo de metodología",
            "Gestión de proyectos"
          ],
          tagline: "Visión estructurada, resultados medibles."
        },
        {
          id: 6,
          title: "Mentoría Agente 360",
          description: "Programa de formación estratégica para futuros agentes profesionales.",
          features: [
            "Fundamentos legales y regulatorios",
            "Técnicas de negociación",
            "Gestión de relaciones",
            "Desarrollo de cartera",
            "Ética y profesionalismo"
          ],
          tagline: "Formamos agentes con criterio, no intermediarios.",
          special: true
        }
      ]
    },
    specialization: {
      title: "ESPECIALIZACIÓN",
      areas: [
        "Fútbol femenino profesional",
        "Desarrollo de porteros de élite",
        "Scouting y detección temprana de talento",
        "Operaciones en Europa y Latinoamérica"
      ],
      tagline: ["La especialización genera profundidad.", "La profundidad genera resultados."]
    },
    scoutingCta: {
      text: "¿Eres jugador/a con proyección internacional?",
      button: "ENVIAR MI PERFIL"
    },
    methodology: {
      title: "METODOLOGÍA",
      intro: "No vendemos sueños. Ejecutamos planes.",
      steps: [
        "Análisis exhaustivo del perfil y objetivos",
        "Diseño de estrategia personalizada",
        "Ejecución con precisión y timing",
        "Seguimiento y optimización continua"
      ],
      tagline: ["El mercado no espera.", "La preparación es la ventaja."]
    },
    founder: {
      title: "FOUNDER & STRATEGIC DIRECTOR",
      name: "Edgar Merino",
      subtitle: "Fundador de Ikons Agency y Solo Cracks",
      description: "Edgar Merino es fundador de Ikons Agency y Solo Cracks, firmas especializadas en representación estratégica dentro del fútbol profesional.",
      extendedDescription: [
        "Con una visión centrada en la planificación de carrera, la negociación inteligente y el posicionamiento internacional, ha construido una red sólida en Europa y Latinoamérica basada en confianza, criterio y relaciones sostenidas en el tiempo."
      ],
      principles: [
        "Planificación estructurada",
        "Negociación profesional",
        "Construcción de relaciones sostenidas",
        "Desarrollo integral de carrera"
      ],
      tagline: ["Su enfoque combina estrategia, estructura y visión de largo plazo."]
    },
    exclusive: {
      title: "BY INVITATION ONLY",
      description: "En Ikons Agency trabajamos bajo un modelo de representación selectiva.",
      statement: "No todos los perfiles son incorporados.",
      criteria: [
        "Ambición profesional clara",
        "Disciplina y compromiso",
        "Mentalidad de crecimiento",
        "Proyección real en el mercado"
      ],
      philosophy: [
        "La exclusividad no es un lujo.",
        "Es un estándar de calidad."
      ]
    },
    clubs: {
      title: "Clubes que han confiado en nosotros",
      subtitle: "Trabajamos con algunas de las instituciones más prestigiosas del fútbol mundial"
    },
    brands: {
      title: "Marcas asociadas",
      subtitle: "Colaboramos con marcas líderes en diferentes industrias"
    },
    faq: {
      title: "PREGUNTAS FRECUENTES",
      questions: [
        {
          q: "¿Cómo puedo ser representado por Ikons Agency?",
          a: "Trabajamos bajo un modelo selectivo. Si consideras que tu perfil encaja con nuestra filosofía, puedes contactarnos para una evaluación inicial."
        },
        {
          q: "¿Trabajan solo con jugadores de élite?",
          a: "Trabajamos con perfiles que demuestren proyección real, compromiso profesional y mentalidad de crecimiento. No se trata solo del nivel actual, sino del potencial y la actitud."
        },
        {
          q: "¿En qué mercados operan?",
          a: "Principalmente en Europa y Latinoamérica, con una red consolidada de contactos en las principales ligas."
        },
        {
          q: "¿Qué diferencia a Ikons Agency de otras agencias?",
          a: "Nuestro enfoque estratégico a largo plazo, la atención personalizada, y la combinación de experiencia deportiva real con conocimiento profundo del mercado."
        },
        {
          q: "¿Ofrecen servicios para agentes en formación?",
          a: "Sí, a través de nuestro programa Mentoría Agente 360, diseñado para formar agentes con criterio profesional y visión estratégica."
        }
      ]
    },
    contact: {
      title: "CONTACTO",
      subtitle: "¿Listo para dar el siguiente paso en tu carrera?",
      form: {
        name: "Nombre completo",
        contact: "Email o WhatsApp",
        interest: "Interés",
        interestOptions: [
          { value: "jugador", label: "Soy jugador/a" },
          { value: "agente", label: "Soy agente" },
          { value: "club", label: "Represento a un club" },
          { value: "otro", label: "Otro" }
        ],
        message: "Mensaje",
        messagePlaceholder: "Cuéntanos brevemente tu situación y objetivos...",
        submit: "AGENDAR REUNIÓN PRIVADA",
        whatsapp: "WhatsApp",
        email: "Email"
      }
    },
    footer: {
      tagline: ["Construimos carreras con intención.", "Gestionamos talento con precisión.", "Creamos legado con estrategia."],
      legal: [
        { label: "Aviso Legal", url: "#" },
        { label: "Política de Privacidad", url: "#" },
        { label: "Política de Cookies", url: "#" }
      ]
    }
  },
  
  en: {
    nav: {
      services: "Services",
      specialization: "Specialization",
      founder: "Founder",
      faq: "FAQ",
      contact: "Contact"
    },
    hero: {
      title: "IKONS AGENCY",
      subtitle: "Strategic Football Representation",
      tagline: ["Elite management.", "International vision.", "Long-term structure."],
      cta: {
        primary: "REQUEST PRIVATE CONSULTATION",
        secondary: "CONTACT VIA WHATSAPP"
      }
    },
    vision: {
      headline: "The difference is in the structure.",
      subheadline: "Talent opens doors. Strategy builds careers.",
      description: [
        "At Ikons Agency we work with planning, criteria and international vision.",
        "Every decision responds to a strategy.",
        "Every move has purpose.",
        "",
        "We don't improvise operations.",
        "We design sustainable trajectories."
      ]
    },
    about: {
      title: "WHO WE ARE",
      description: "Ikons Agency is a representation and strategic advisory firm in the football industry.",
      features: [
        "Real sports experience",
        "Deep market knowledge",
        "Consolidated international network",
        "Professional negotiation",
        "Comprehensive career management"
      ],
      tagline: "We operate with discretion, precision and long-term focus."
    },
    services: {
      title: "SERVICES",
      list: [
        {
          id: 1,
          title: "Sports Representation",
          description: "Comprehensive career management for professional players and coaches.",
          features: [
            "Contract negotiation",
            "Transfer strategy",
            "Sports planning",
            "Asset protection and valorization",
            "Continuous strategic support"
          ],
          tagline: "We build careers, not seasons.",
          special: true
        },
        {
          id: 2,
          title: "Image Representation",
          description: "Strategic development and positioning of personal brand.",
          features: [
            "Sponsorship management",
            "Commercial agreements",
            "Public identity building",
            "Media projection",
            "Sponsorship activation"
          ],
          tagline: "The brand also competes."
        },
        {
          id: 3,
          title: "Sports Intermediation",
          description: "Professional execution of operations between clubs and professionals.",
          features: [
            "Strategic negotiations",
            "Transfer management",
            "Confidential operations",
            "Complex deal structuring"
          ],
          tagline: "Precision, criteria and confidentiality."
        },
        {
          id: 4,
          title: "Club Representation",
          description: "Strategic advisory in player buying and selling processes.",
          features: [
            "Talent identification",
            "Market analysis",
            "Operation structuring",
            "Negotiation support"
          ],
          tagline: "Strategic partners of the club."
        },
        {
          id: 5,
          title: "Sports Management Advisory",
          description: "Strategic consulting for clubs, federations and sports structures.",
          features: [
            "Sports planning",
            "Resource optimization",
            "Methodology development",
            "Project management"
          ],
          tagline: "Structured vision, measurable results."
        },
        {
          id: 6,
          title: "Agent 360 Mentorship",
          description: "Strategic training program for future professional agents.",
          features: [
            "Legal and regulatory fundamentals",
            "Negotiation techniques",
            "Relationship management",
            "Portfolio development",
            "Ethics and professionalism"
          ],
          tagline: "We train agents with criteria, not intermediaries.",
          special: true
        }
      ]
    },
    specialization: {
      title: "SPECIALIZATION",
      areas: [
        "Professional women's football",
        "Elite goalkeeper development",
        "Scouting and early talent detection",
        "Operations in Europe and Latin America"
      ],
      tagline: ["Specialization creates depth.", "Depth creates results."]
    },
    scoutingCta: {
      text: "Are you a player with international projection?",
      button: "SUBMIT MY PROFILE"
    },
    methodology: {
      title: "METHODOLOGY",
      intro: "We don't sell dreams. We execute plans.",
      steps: [
        "Exhaustive analysis of profile and objectives",
        "Custom strategy design",
        "Execution with precision and timing",
        "Continuous monitoring and optimization"
      ],
      tagline: ["The market doesn't wait.", "Preparation is the advantage."]
    },
    founder: {
      title: "FOUNDER & STRATEGIC DIRECTOR",
      name: "Edgar Merino",
      subtitle: "Founder of Ikons Agency and Solo Cracks",
      description: "Edgar Merino is the founder of Ikons Agency and Solo Cracks, firms specialized in strategic representation within professional football.",
      extendedDescription: [
        "With a vision focused on career planning, intelligent negotiation and international positioning, he has built a solid network in Europe and Latin America based on trust, criteria and sustained relationships over time."
      ],
      principles: [
        "Structured planning",
        "Professional negotiation",
        "Building sustained relationships",
        "Comprehensive career development"
      ],
      tagline: ["His approach combines strategy, structure and long-term vision."]
    },
    exclusive: {
      title: "BY INVITATION ONLY",
      description: "At Ikons Agency we work under a selective representation model.",
      statement: "Not all profiles are incorporated.",
      criteria: [
        "Clear professional ambition",
        "Discipline and commitment",
        "Growth mindset",
        "Real market projection"
      ],
      philosophy: [
        "Exclusivity is not a luxury.",
        "It's a quality standard."
      ]
    },
    clubs: {
      title: "Clubs that have trusted us",
      subtitle: "We work with some of the most prestigious institutions in world football"
    },
    brands: {
      title: "Associated brands",
      subtitle: "We collaborate with leading brands in different industries"
    },
    faq: {
      title: "FREQUENTLY ASKED QUESTIONS",
      questions: [
        {
          q: "How can I be represented by Ikons Agency?",
          a: "We work under a selective model. If you think your profile fits our philosophy, you can contact us for an initial evaluation."
        },
        {
          q: "Do you only work with elite players?",
          a: "We work with profiles that demonstrate real projection, professional commitment and growth mindset. It's not just about current level, but potential and attitude."
        },
        {
          q: "In which markets do you operate?",
          a: "Mainly in Europe and Latin America, with a consolidated network of contacts in the main leagues."
        },
        {
          q: "What sets Ikons Agency apart from other agencies?",
          a: "Our long-term strategic approach, personalized attention, and the combination of real sports experience with deep market knowledge."
        },
        {
          q: "Do you offer services for agents in training?",
          a: "Yes, through our Agent 360 Mentorship program, designed to train agents with professional criteria and strategic vision."
        }
      ]
    },
    contact: {
      title: "CONTACT",
      subtitle: "Ready to take the next step in your career?",
      form: {
        name: "Full name",
        contact: "Email or WhatsApp",
        interest: "Interest",
        interestOptions: [
          { value: "jugador", label: "I'm a player" },
          { value: "agente", label: "I'm an agent" },
          { value: "club", label: "I represent a club" },
          { value: "otro", label: "Other" }
        ],
        message: "Message",
        messagePlaceholder: "Tell us briefly about your situation and goals...",
        submit: "SCHEDULE PRIVATE MEETING",
        whatsapp: "WhatsApp",
        email: "Email"
      }
    },
    footer: {
      tagline: ["We build careers with intention.", "We manage talent with precision.", "We create legacy with strategy."],
      legal: [
        { label: "Legal Notice", url: "#" },
        { label: "Privacy Policy", url: "#" },
        { label: "Cookie Policy", url: "#" }
      ]
    }
  }
};

// Club and brand data (same for both languages, just labels change)
export const clubsData = [
  { name: "FC Barcelona", country: { es: "España", en: "Spain" }, logo: "/logos/clubs/barcelona.svg" },
  { name: "Real Madrid", country: { es: "España", en: "Spain" }, logo: "/logos/clubs/real-madrid.svg" },
  { name: "Bayern Munich", country: { es: "Alemania", en: "Germany" }, logo: "/logos/clubs/bayern.svg" },
  { name: "Paris Saint-Germain", country: { es: "Francia", en: "France" }, logo: "/logos/clubs/psg.svg" },
  { name: "Tigres UANL", country: { es: "México", en: "Mexico" }, logo: "/logos/clubs/tigres.svg" },
  { name: "Chelsea FC", country: { es: "Inglaterra", en: "England" }, logo: "/logos/clubs/chelsea.svg" },
  { name: "Inter Milan", country: { es: "Italia", en: "Italy" }, logo: "/logos/clubs/inter-milan.svg" },
  { name: "Servette FC", country: { es: "Suiza", en: "Switzerland" }, logo: "/logos/clubs/servette.svg" },
  { name: "Sevilla FC", country: { es: "España", en: "Spain" }, logo: "/logos/clubs/sevilla.svg" },
  { name: "Valencia CF", country: { es: "España", en: "Spain" }, logo: "/logos/clubs/valencia.svg" }
];

export const brandsData = [
  { name: "Santander", category: { es: "Financiero", en: "Financial" }, logo: "/logos/brands/santander.svg" },
  { name: "adidas", category: { es: "Deportes", en: "Sports" }, logo: "/logos/brands/adidas.svg" },
  { name: "Nike", category: { es: "Deportes", en: "Sports" }, logo: "/logos/brands/nike.svg" },
  { name: "Puma", category: { es: "Deportes", en: "Sports" }, logo: "/logos/brands/puma.svg" },
  { name: "Coca-Cola", category: { es: "Bebidas", en: "Beverages" }, logo: "/logos/brands/coca-cola.svg" }
];

export const playersData = [
  { src: "/images/players/player1.jpg", alt: { es: "Jugador profesional", en: "Professional player" } },
  { src: "/images/players/player2.jpg", alt: { es: "Jugador profesional", en: "Professional player" } },
  { src: "/images/players/player3.jpg", alt: { es: "Jugador profesional", en: "Professional player" } },
  { src: "/images/players/player4.jpg", alt: { es: "Jugador profesional", en: "Professional player" } }
];
